/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Studio Zones
 */
export enum StudioZone {
    NewYork = 'New York',
    NewYorkCity = 'New York City',
    LosAngeles = 'Los Angeles',
}
